var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Tipo de Endereço",
                          "label-for": "address_type_id",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("address.type"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      staticClass: "required-select",
                                      attrs: {
                                        id: "address_type_id",
                                        options: _vm.addressTypeList,
                                        label: "name",
                                      },
                                      model: {
                                        value: _vm.address.addressType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.address,
                                            "addressType",
                                            $$v
                                          )
                                        },
                                        expression: "address.addressType",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options",
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      ),
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "CEP", "label-for": "postal_code" } },
                      [
                        _c("validation-provider", {
                          attrs: { name: _vm.$t("address.postal_code") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "##.###-###",
                                        expression: "'##.###-###'",
                                      },
                                    ],
                                    attrs: {
                                      id: "postal_code",
                                      state: errors.length > 0 ? false : null,
                                      name: "postal_code",
                                    },
                                    model: {
                                      value: _vm.address.postalCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.address, "postalCode", $$v)
                                      },
                                      expression: "address.postalCode",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-3/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Logradouro",
                          "label-for": "street_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("address.street_name"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      id: "street_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "street_name",
                                    },
                                    model: {
                                      value: _vm.address.streetName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.address, "streetName", $$v)
                                      },
                                      expression: "address.streetName",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/5 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Número",
                          "label-for": "street_number",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: _vm.$t("address.street_number") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "street_number",
                                      state: errors.length > 0 ? false : null,
                                      name: "street_number",
                                      type: "number",
                                    },
                                    model: {
                                      value: _vm.address.streetNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.address,
                                          "streetNumber",
                                          $$v
                                        )
                                      },
                                      expression: "address.streetNumber",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Bairro",
                          "label-for": "district_name",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: _vm.$t("address.district_name") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "district_name",
                                      state: errors.length > 0 ? false : null,
                                      name: "district_name",
                                    },
                                    model: {
                                      value: _vm.address.districtName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.address,
                                          "districtName",
                                          $$v
                                        )
                                      },
                                      expression: "address.districtName",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Estado",
                          "label-for": "federation_unit",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("address.federation_unit"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      staticClass: "required-select",
                                      attrs: {
                                        options: _vm.federationUnitList,
                                        label: "name",
                                      },
                                      on: { input: _vm.selectFederationUnit },
                                      model: {
                                        value: _vm.address.federationUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.address,
                                            "federationUnit",
                                            $$v
                                          )
                                        },
                                        expression: "address.federationUnit",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options",
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      ),
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Cidade", "label-for": "city_id" } },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("address.city"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      staticClass: "required-select",
                                      attrs: {
                                        id: "city_id",
                                        options: _vm.cityList,
                                        label: "name",
                                        disabled: !_vm.showCityList,
                                      },
                                      model: {
                                        value: _vm.address.city,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.address, "city", $$v)
                                        },
                                        expression: "address.city",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options",
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      ),
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("address.latitude"),
                          "label-for": "latitude",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: _vm.$t("address.latitude") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "latitude",
                                      state: errors.length > 0 ? false : null,
                                      name: "latitude",
                                    },
                                    model: {
                                      value: _vm.address.address_geo.latitude,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.address.address_geo,
                                          "latitude",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "address.address_geo.latitude",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("address.longitude"),
                          "label-for": "longitude",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: _vm.$t("address.longitude") },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "longitude",
                                      state: errors.length > 0 ? false : null,
                                      name: "longitude",
                                    },
                                    model: {
                                      value: _vm.address.address_geo.longitude,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.address.address_geo,
                                          "longitude",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "address.address_geo.longitude",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "float-right",
                        model: {
                          value: _vm.address.head,
                          callback: function ($$v) {
                            _vm.$set(_vm.address, "head", $$v)
                          },
                          expression: "address.head",
                        },
                      },
                      [_vm._v("Endereço principal")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row mt-2" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _vm.editMode
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "float-right ",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.cancelEdit },
                          },
                          [_vm._v(" Limpar ")]
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        class: ["float-right", { "mr-2": _vm.editMode }],
                        attrs: {
                          variant: "primary",
                          type: "submit",
                          disabled: !_vm.validateForm,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(this.editMode ? "Alterar" : "Adicionar") +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "vx-row mt-4 mb-10" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.addressList,
                  "no-data-text": "Nenhum registro encontrado",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var data = ref.data
                      return _vm._l(data, function (tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr },
                          [
                            _c("vs-td", [
                              _vm._v(
                                _vm._s(_vm._.get(tr, "address_type.name"))
                              ),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].postal_code)),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].street_name)),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].street_number)),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].district_name)),
                            ]),
                            _c("vs-td", [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(tr, "city.federation_unit.name")
                                )
                              ),
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(_vm._.get(tr, "city.name"))),
                            ]),
                            _c("vs-td", [
                              data[indextr].pivot.head
                                ? _c("span", [_vm._v("Sim")])
                                : _c("span", [_vm._v("Não")]),
                            ]),
                            _c("vs-td", [
                              _c(
                                "div",
                                { staticClass: "flex flex-row gap-2" },
                                [
                                  _c("feather-icon", {
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-warning",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      icon: "EditIcon",
                                      title: "Editar",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(data[indextr])
                                      },
                                    },
                                  }),
                                  _c("feather-icon", {
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-danger",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      icon: "Trash2Icon",
                                      title: "Excluir",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.destroy(data[indextr])
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Tipo")]),
                    _c("vs-th", [_vm._v("CEP")]),
                    _c("vs-th", [_vm._v("Logradouro")]),
                    _c("vs-th", [_vm._v("Número")]),
                    _c("vs-th", [_vm._v("Bairro")]),
                    _c("vs-th", [_vm._v("Estado")]),
                    _c("vs-th", [_vm._v("Cidade")]),
                    _c("vs-th", [_vm._v("Principal")]),
                    _c("vs-th", [_vm._v("Ação")]),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }